//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsPhoenixRestApi,getLineItemsApi,createLineItemApi,updateLineItemApi,
    moveDownLineItemApi,moveUpLineItemApi,deleteLineItemApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type,EditForm$Type,PostForm$Type } from '../genericFlowTypes'

const workflowType = 'Athena'

export const getTaskData=(athena:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.ATHENA_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,athena)
            dispatch({
                type: actionTypes.ATHENA_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.ATHENA_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.ATHENA_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,athenaResultset:any,athena:ReducerState$Type)=>{
    let payload:PostForm$Type={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (athenaResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=athenaResultset.vendorName;
        payload.invNo=athenaResultset.invNo;
        payload.invDate=athenaResultset.invDate;
        payload.bookingNo=athenaResultset.bookingNo;
        payload.referenceNo=athenaResultset.referenceNo;
        payload.total=athenaResultset.total;
        payload.isInvalidDoc=athenaResultset.isInvalidDoc?athenaResultset.isInvalidDoc:false;
        payload.isOverrideTotal=athenaResultset.isOverrideTotal?athenaResultset.isOverrideTotal:false;
        payload.isOverrideVendorName=athenaResultset.isOverrideVendorName?athenaResultset.isOverrideVendorName:false;
    }

    if (athena.reviewQuestions && athena.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(athenaResultset,athena.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.ATHENA_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.ATHENA_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.ATHENA_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.ATHENA_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsPhoenixRestApi(jwt,workflowType.toLowerCase())
    .then((resp) => resp.json()).then(data =>{
        dispatch({type: actionTypes.REFRESH_ATHENA_VENDORS_SUCCESS, vendors: data });
        
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_ATHENA_VENDORS_ERROR, error: err});
    })
}

export const getLineItems=(jwt:any,page:number,pageSize:number,sortField:string,sortOrder:any,taskAcceptedInfoId:number)=>{
    return (dispatch:Dispatch$Type) => getLineItemsApi(jwt,workflowType,page,pageSize,sortField,sortOrder,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.GET_ATHENA_ITEMS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.GET_ATHENA_ITEMS_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.GET_ATHENA_ITEMS_ERROR,error: err});
    })
}

export const setPage=(jwt:any,athena:ReducerState$Type,page:number)=>{
    return getLineItems(jwt,page,(athena.pageSize:any),(athena.sortField:any),athena.sortOrder,(athena.taskAcceptedInfoId:any));
}

export const setPageSize=(jwt:any,athena:ReducerState$Type,pageSize:number)=>{
    return getLineItems(jwt,(athena.page:any),pageSize,(athena.sortField:any),athena.sortOrder,(athena.taskAcceptedInfoId:any));
}

export const sortData=(jwt:any,athena:ReducerState$Type,sortField:any,sortOrder:any)=>{
    return getLineItems(jwt,(athena.page:any),(athena.pageSize:any),sortField,sortOrder,(athena.taskAcceptedInfoId:any));
}

export const createNewLineItem=(jwt:any,newLineItem:any,taskAcceptedInfoId:number)=>{
    return (dispatch:Dispatch$Type) => createLineItemApi(jwt,workflowType,newLineItem,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.CREATE_NEW_ATHENA_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.CREATE_NEW_ATHENA_ITEM_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.CREATE_NEW_ATHENA_ITEM_ERROR,error: err});
    })
}

export const editLineItem=(lineItem:any)=>{
    let convertToFormObj={};
    convertToFormObj.id=lineItem.id;
    convertToFormObj.itemDesc=lineItem.item_desc;
    convertToFormObj.itemQty=lineItem.item_qty;
    convertToFormObj.itemPrice=lineItem.item_price;
    convertToFormObj.itemTotal=lineItem.item_total;
    convertToFormObj.isOverrideNaItemQty=lineItem.is_override_na_item_qty;
    convertToFormObj.isOverrideNaItemPrice=lineItem.is_override_na_item_price;
    convertToFormObj.isOverrideItemTotal=lineItem.is_override_item_total;
    
    return { type: actionTypes.EDIT_ATHENA_ITEM, lineItem: convertToFormObj };
}

export const updateLineItem=(jwt:any,updateLineItem:any,id:number)=>{
    return (dispatch:Dispatch$Type) => updateLineItemApi(jwt,workflowType,updateLineItem,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATE_ATHENA_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.UPDATE_ATHENA_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATE_ATHENA_ITEM_ERROR,error: err});
    })
}

export const moveDownLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => moveDownLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_DOWN_ATHENA_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_DOWN_ATHENA_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_DOWN_ATHENA_ITEM_ERROR,error: err});
    })
}

export const moveUpLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => moveUpLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_UP_ATHENA_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_UP_ATHENA_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_UP_ATHENA_ITEM_ERROR,error: err});
    })
}

export const deleteLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => deleteLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.DELETE_ATHENA_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.DELETE_ATHENA_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.DELETE_ATHENA_ITEM_ERROR,error: err});
    })
}

export const openAddEditLineItemForm=()=>{
    return { type: actionTypes.OPEN_ADD_EDIT_LINEITEM_FORM };
}

export const lineItemSelectedId=(id:number)=>{
    return { type: actionTypes.SELECTED_ATHENA_ITEM_ID, lineItemId: id}
}

export const cancelAddEditLineItemForm=()=>{
    return { type: actionTypes.CANCEL_ADD_EDIT_LINEITEN_FORM };
}


// WEBPACK FOOTER //
// ./src/redux/athena/actions.js